module.exports = __webpack_public_path__ + "images/marketing_site/googleplay-mailer-2026.png";